/* eslint-disable unused-imports/no-unused-imports */
import React from "react"
import connect from "./connect"
import {
    ClearButton,
    getSaleClearanceAssetPath,
    HiddenLabel,
    InputContainer,
    SaleClearanceForm,
    SaleClearanceImageContainer,
    SearchBarContainer,
    SearchBarInnerContainer,
    SubmitButton,
} from "./components"
import {useSearchBox} from "./hooks"
import {TIsUrlSaleOrClearance} from "../../models/Request"

type Props = {
    saleClearanceSearchTerm: string
    onTyping: (chars: string) => void
    text: any
    placeholder: string
    submitButtonIconPath: string
    clearButtonIconPath: string
    saleClearanceImagePath: string
    siteUrl: string
    onSubmit: (siteUrl: string, saleOrClearance: string, searchTerm: string) => void
    saleOrClearance: TIsUrlSaleOrClearance["saleOrClearance"]
    urlIsSaleOrClearance: boolean
}

export const SaleClearanceSearchBar = ({
    saleClearanceSearchTerm,
    onTyping,
    text,
    onSubmit,
    placeholder,
    submitButtonIconPath,
    clearButtonIconPath,
    saleClearanceImagePath,
    siteUrl,
    saleOrClearance,
    urlIsSaleOrClearance,
}: Props) => {
    const {
        handleClear,
        handleChange,
        handleSubmit: handleFormSubmit,
        setTextInputRef,
    } = useSearchBox({
        siteUrl,
        searchTerm: saleClearanceSearchTerm,
        onSubmit,
        onTyping,
        saleOrClearance,
    })

    if (!urlIsSaleOrClearance) {
        return null
    }

    return (
        <SearchBarContainer $saleOrClearance={saleOrClearance} id="plp-sale-clearance-container">
            <SearchBarInnerContainer id="plp-sale-clearance-inner-container">
                <SaleClearanceImageContainer
                    id="plp-sale-clearance-image-container"
                    data-testid="plp-sale-clearance-image-container"
                >
                    <img src={getSaleClearanceAssetPath(saleClearanceImagePath)} alt={saleOrClearance} />
                </SaleClearanceImageContainer>
                <SaleClearanceForm
                    action={`${siteUrl}/${saleOrClearance}/search`}
                    onSubmit={handleFormSubmit}
                    id="plp-sale-clearance-form"
                    data-testid="plp-sale-clearance-form"
                >
                    <HiddenLabel htmlFor={text.labelId}>{placeholder}</HiddenLabel>
                    <InputContainer
                        inputRef={setTextInputRef}
                        autoComplete="off"
                        inputProps={{
                            label: text.label,
                            "data-testid": `plp-sale-clearance-search-bar-text-input`,
                        }}
                        type="text"
                        onChange={handleChange}
                        placeholder={placeholder}
                        value={saleClearanceSearchTerm}
                        name="w"
                        id={text.labelId}
                    />
                    {saleClearanceSearchTerm && (
                        <ClearButton
                            href="#"
                            data-testid={`plp-${saleOrClearance}-search-bar-clear-text-button`}
                            onClick={handleClear}
                            tabIndex={0}
                        >
                            <img
                                src={getSaleClearanceAssetPath(clearButtonIconPath)}
                                alt={`Clear ${saleOrClearance} button`}
                            />
                        </ClearButton>
                    )}
                    <SubmitButton
                        type="submit"
                        value=""
                        data-testid="plp-sale-clearance-search-bar-button"
                        tabIndex={0}
                        disableRipple
                    >
                        <img
                            src={getSaleClearanceAssetPath(submitButtonIconPath)}
                            alt={`Search ${saleOrClearance} button`}
                        />
                    </SubmitButton>
                </SaleClearanceForm>
            </SearchBarInnerContainer>
        </SearchBarContainer>
    )
}

export default connect(SaleClearanceSearchBar)
